import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsFontColorSvg } from './WpsFontColorSvg'

export const WpsFontColorIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={WpsFontColorSvg} {...props} />
)
